module.exports = __webpack_public_path__ + "static/media/icecream_filled.c3936b2e.svg";